export const threeJsSounds = {
  ballHit: () => {},
  ballHit2: () => {},
  ballHit3: () => {},
  ballFinish: () => {},
  ballLoop: () => {},
  stopBallLoop: () => {},
  randomHit: () => {
    const a = Math.random();
    if (a > 0.6) {
      threeJsSounds.ballHit();
    } else if (a > 0.3) {
      threeJsSounds.ballHit2();
    } else {
      threeJsSounds.ballHit3();
    }
  },
};
